const PITCH_OFFSET = -4;
const ENABLE_PHOTO_GROUPS = import.meta.env.VITE_ENABLE_PHOTO_GROUPS === 'true';

export { PITCH_OFFSET, ENABLE_PHOTO_GROUPS };